<ng-container *ngIf="displayError$ | async">
  <!-- #crowdin -->
  <app-text class="text-align-center is-family-bold is-size-4">{{'The administrator of your building needs to reconnect'}}</app-text>

  <img src="assets/images/no-device.svg">

</ng-container>
